{
  "aboutCluster": "Om nettverket",
  "accountSettings": "Kontoinnstillinger",
  "addEvent": "Legg til event",
  "addMeeting": "Legg til møte",
  "advisors": "Rådgivere",
  "boardGroup": "Styringsgruppe",
  "businessDescription": "Virksomhetsbeskrivelse",
  "clusterManagement": "Ledelse",
  "companyInformation": "Selskapsinformasjon",
  "contactDetails": "Kontaktdetaljer",
  "contactInformation": "Kontaktinformasjon",
  "contacts": "Kontakter",
  "economyEsaReporting": "Økonomi/ESA-rapportering",
  "fastContactRegistration": "Rask kontaktregistrering",
  "fastDeductibleRegistration": "Rask registrering av egenandel",
  "fastInKindRegistration": "Rask egeninnsatsregistrering",
  "fastMemberRegistration": "Rask medlemsregistrering",
  "focusAreas": "Fokusområder",
  "grunndata": "Grunndata",
  "inkindOverview": "Oversikt egeninnsats",
  "interestAreas": "Interesseområder",
  "mainGoals": "Hovedmål",
  "memberContribution": "Medlemsbidrag og egeninnsats",
  "memberInformation": "Medlemsinformasjon",
  "membershipFees": "Medlemskontingent",
  "projectCategories": "Prosjektkategorier",
  "registerDeductible": "Registrer egenandel",
  "timeRates": "Timesats",
  "visionMission": "Visjon og Misjon",
  "yourProfile": "Profilen din",
  "accessControl": "Tilgangsstyring"
}
